import React from "react";
import PropTypes from "prop-types";
import { Building2 } from "lucide-react";

import { UIEmptyState } from "../../../../../../components/ui";

const CompaniesEmptyState = ({ title, description }) => (
  <UIEmptyState
    title={title}
    description={description}
    icon={<Building2 aria-hidden />}
    classNames={{ root: "ui-empty-state--embedded" }}
  />
);

CompaniesEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default CompaniesEmptyState;
